export var SrciEventListenerEnumsObj = {
    PAYAIR_SRCI_SDK_LISTENER: "PAYAIR_SRCI_SDK_LISTENER",
};
